import { createContext, useContext, type ReactNode } from 'react';
import type { IdControlCapabilities } from './types';

const IdControlContext = createContext<IdControlCapabilities>({});

/**
 * Provides the set of capabilities <IdControl /> can expose in its menu.
 * Mount near the root of each app. If unmounted, IdControl falls back to
 * copy-only behavior (today's CopyId).
 */
export function IdControlProvider({
  capabilities,
  children,
}: {
  capabilities: IdControlCapabilities;
  children: ReactNode;
}) {
  return (
    <IdControlContext.Provider value={capabilities}>
      {children}
    </IdControlContext.Provider>
  );
}

export function useIdControlCapabilities(): IdControlCapabilities {
  return useContext(IdControlContext);
}
